import { BaseJsonObject } from './models'

abstract class XyoWorldBase<T extends BaseJsonObject> {
  public toJSON(): string {
    return JSON.stringify(this.toJsonObject())
  }
  abstract loadJsonObject(jsonObject?: T): XyoWorldBase<T>

  abstract toJsonObject(): T
}

export { XyoWorldBase }
